import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Select from "react-select";

const AddVarientNew = ({ modalData = {}, setModalData, onSubmit }) => {
  /* ---------------- OPTIONS ---------------- */

  const barcodesymbol = [
    { value: "choose", label: "Choose" },
    { value: "code34", label: "Code34" },
    { value: "code35", label: "Code35" },
    { value: "code36", label: "Code36" },
  ];

  const taxtype = [
    { value: "exclusive", label: "Exclusive" },
    { value: "salesTax", label: "Sales Tax" },
  ];

  const tax = [
    { value: "direct", label: "Direct" },
    { value: "indirect", label: "InDirect" },
  ];

  const discounttype = [
    { value: "choose", label: "Choose" },
    { value: "percentage", label: "Percentage" },
    { value: "cash", label: "Cash" },
  ];

  /* ---------------- HANDLER ---------------- */

  const handleChange = (field, value) => {
    setModalData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  /* ---------------- IMAGE HANDLER ---------------- */

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const base64 = await toBase64(file);
      handleChange("image", base64);
    } catch (err) {
      console.error(err);
    }
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="modal fade" id="add-variation">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header">
            <h4>{window.translate("addVariant")}</h4>
            <button
              type="button"
              className="close bg-danger text-white fs-16"
              data-bs-dismiss="modal"
            >
              ×
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body">
            {/* -------- Variant Thumbnail Section -------- */}

            <h6 className="mb-3">{window.translate("variantThumbnail")}</h6>

            <div
              className="d-flex align-items-start gap-4 mb-4"
              style={{ flexWrap: "wrap" }}
            >
              {/* Upload Box */}
              <div>
                <label
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 120,
                    height: 120,
                    border: "1px dashed #ccc",
                    borderRadius: 8,
                    cursor: "pointer",
                    background: "#f9f9f9",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    hidden
                  />
                  <span>{window.translate("addImage")}</span>
                </label>
              </div>

              {/* Preview */}
              {modalData?.image && (
                <div
                  className="position-relative"
                  style={{
                    width: 120,
                    height: 120,
                  }}
                >
                  <img
                    src={modalData.image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "1px solid #ddd",
                    }}
                  />

                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute"
                    style={{
                      top: -8,
                      right: -8,
                      borderRadius: "50%",
                      width: 25,
                      height: 25,
                      padding: 0,
                    }}
                    onClick={() => handleChange("image", null)}
                  >
                    ×
                  </button>
                </div>
              )}
            </div>

            {/* -------- FORM FIELDS -------- */}

            <div className="row">
              {/* Barcode */}
              <div className="col-lg-6">
                <label className="form-label">
                  {window.translate("barcodeSymbology")}
                  <span className="text-danger">*</span>
                </label>

                <Select
                  options={barcodesymbol}
                  value={
                    barcodesymbol.find(
                      (o) => o.value === modalData?.barcodeSymbology,
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange("barcodeSymbology", selected?.value || "")
                  }
                />
              </div>

              {/* Item Code */}
              <div className="col-lg-6">
                <label className="form-label">
                  {window.translate("itemCode")}
                  <span className="text-danger">*</span>
                </label>

                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    value={modalData?.itemCode || ""}
                    onChange={(e) => handleChange("itemCode", e.target.value)}
                  />

                  <button
                    type="button"
                    className="btn btn-warning position-absolute"
                    style={{
                      top: 0,
                      right: 0,
                      height: "100%",
                    }}
                    onClick={() =>
                      handleChange(
                        "itemCode",
                        "ITM-" + Math.floor(Math.random() * 1000000),
                      )
                    }
                  >
                    {window.translate("generate")}
                  </button>
                </div>
              </div>

              {/* Quantity */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("quantity")}
                  <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={modalData?.quantity ?? ""}
                  onChange={(e) =>
                    handleChange("quantity", Number(e.target.value))
                  }
                />
              </div>

              {/* Quantity Alert */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("quantityAlert")}
                  <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={modalData?.quantityAlert ?? ""}
                  onChange={(e) =>
                    handleChange("quantityAlert", Number(e.target.value))
                  }
                />
              </div>

              {/* Tax Type */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("taxType")}
                  <span className="text-danger">*</span>
                </label>

                <Select
                  options={tax}
                  value={tax.find((o) => o.value === modalData?.tax) || null}
                  onChange={(selected) =>
                    handleChange("tax", selected?.value || "")
                  }
                />
              </div>

              {/* Tax */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("tax")}
                  <span className="text-danger">*</span>
                </label>

                <Select
                  options={taxtype}
                  value={
                    taxtype.find((o) => o.value === modalData?.taxType) || null
                  }
                  onChange={(selected) =>
                    handleChange("taxType", selected?.value || "")
                  }
                />
              </div>

              {/* Discount Type */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("discountType")}
                  <span className="text-danger">*</span>
                </label>

                <Select
                  options={discounttype}
                  value={
                    discounttype.find(
                      (o) => o.value === modalData?.discountType,
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange("discountType", selected?.value || "")
                  }
                />
              </div>

              {/* Discount Value */}
              <div className="col-lg-6 mt-3">
                <label className="form-label">
                  {window.translate("discountValue")}
                  <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={modalData?.discountValue ?? ""}
                  onChange={(e) =>
                    handleChange("discountValue", Number(e.target.value))
                  }
                />
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <Link to="#" className="btn btn-secondary" data-bs-dismiss="modal">
              {window.translate("cancel")}
            </Link>

            <button
              type="button"
              className="btn btn-primary"
              onClick={async () => {
                await onSubmit(modalData);

                const modalElement = document.getElementById("add-variation");

                if (modalElement) {
                  const modal =
                    window.bootstrap.Modal.getInstance(modalElement) ||
                    new window.bootstrap.Modal(modalElement);

                  modal.hide();
                }
              }}
            >
              {window.translate("submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AddVarientNew.propTypes = {
  modalData: PropTypes.object,
  setModalData: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddVarientNew;
